import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from 'src/app/core/services/app-config.service';
import { AppConfig } from '../models/config-variable.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CarParking } from '../models/carParking.model';
import { Population } from '../models/population.model';

@Injectable({
  providedIn: 'root',
})
export class ParkingService {

	readonly ApiUrl:string = "/parkings";
	readonly config: AppConfig=new AppConfig;

	constructor(private http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) {
		this.config = config;
		this.ApiUrl = this.config.ApiUrl + this.ApiUrl;
	}

	public  getAll(): Observable<CarParking[]> {
		const url = `${this.ApiUrl}/`;
		/*return this.http.get<CarParking[]>(url).pipe(
			map((employees: CarParking[]) => {
			return employees.map(e => new CarParking(e, this.config));
			}),
		);*/
		return this.http.get<CarParking[]>(url);
	}
}
